import React from 'react';
import { Epoch } from '../../types/epochs';
import { getEpochYears, isOngoing } from '../../utils/epochUtils';
import { useTransition } from '../../contexts/TransitionContext';
import { useMusic } from '../../contexts/MusicContext';

interface EpochItemProps {
  epoch: Epoch;
  index: number;
  currentYear: number;
  epochRefs: React.MutableRefObject<{ [key: string]: HTMLDivElement | null }>;
  calculateVerticalPosition: (index: number) => number;
  calculatePositions: (startYear: number, endYear: number) => {
    startPosition: number;
    width: number;
  };
  setHoveredEpoch: (epoch: string | null) => void;
  onClose?: () => void;
}

export const EpochItem: React.FC<EpochItemProps> = ({
  epoch,
  index,
  currentYear,
  epochRefs,
  calculateVerticalPosition,
  calculatePositions,
  setHoveredEpoch,
  onClose
}) => {
  const { setIsPageTransitioning, setIsSceneLoaded } = useTransition();
  const epochYears = getEpochYears(epoch);
  const startYear = Math.min(...epochYears);
  const endYear = epoch.period.toLowerCase().includes('present') ? currentYear : Math.max(...epochYears);
  const params = new URLSearchParams(window.location.search);
  const target = params.get('target')?.toLowerCase().replaceAll('_', ' ') || '';
  const { fadeAndNavigate } = useMusic();

  const { startPosition, width } = calculatePositions(startYear, endYear);
  const topPosition = Number(calculateVerticalPosition(index).toFixed(3));

  const handleClick = () => {
    if (onClose) {
      onClose();
    }

    setIsSceneLoaded(false);
    setIsPageTransitioning(true);
    fadeAndNavigate(`/museum?target=${encodeURIComponent(epoch.title.replaceAll(' ', '_').toLowerCase())}&preloader=true`);
  };

  return (
    <div
      key={epoch.title}
      ref={el => epochRefs.current[epoch.title] = el}
      className={`epoch ${isOngoing(epoch.period) && 'ongoing'} ${target === epoch.title.toLocaleLowerCase() && 'active'}`}
      style={{
        left: `${startPosition}%`,
        width: `${width}%`,
        top: `${topPosition}vw`,
        '--epoch-color': epoch.color
      } as React.CSSProperties}
      onMouseEnter={() => setHoveredEpoch(epoch.title)}
      onMouseLeave={() => setHoveredEpoch(null)}
      onClick={handleClick}
    >
      {epoch.title}
      <span className="period">{epoch.period}</span>
    </div>
  );
}; 